import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import moment from 'moment';
import { IJournalEquipmentHistory } from '../interfaces';

const useStyles = makeStyles({
  table: {
    '& thead': {
      '& th': {
        fontWeight: 600,
        backgroundColor: '#FDD7E7',
      },
    },

    '& tbody': {
      '& tr': {
        '& td': {
          backgroundColor: '#FAFAFA',
          transition: 'background-color 200ms',
        },
        '&:hover': {
          '& td': {
            backgroundColor: '#f5f5f5',
          },
        },
      },
    },
  },
});

interface IProps {
  history?: IJournalEquipmentHistory[];
  disabled: boolean;
  onClose(): void;
}

const JournalEquipmentHistoryDialog: React.FC<IProps & DialogProps> = ({ open, history, disabled, onClose }) => {
  // Styles
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle>
        <b>История изменений</b>
      </DialogTitle>

      <DialogContent dividers>
        <TableContainer component={Paper} variant="outlined">
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Автор</b>
                </TableCell>

                <TableCell>
                  <b>Время</b>
                </TableCell>

                <TableCell>
                  <b>Статус</b>
                </TableCell>

                <TableCell>
                  <b>Комментарий</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {history?.map(
                ({ comment, createAt, createUserName, journalEquipmentStatusName, journalEquipmentHistoryId }) => (
                  <TableRow key={journalEquipmentHistoryId}>
                    <TableCell>{createUserName}</TableCell>
                    <TableCell>{moment(createAt).format('DD-MM-YYYY HH:mm')}</TableCell>
                    <TableCell>{journalEquipmentStatusName}</TableCell>
                    <TableCell>{comment ?? '—'}</TableCell>
                  </TableRow>
                ),
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" disabled={disabled} onClick={onClose} startIcon={<Cancel />}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JournalEquipmentHistoryDialog;
